import { snakeCase } from 'lodash-es';
import { ACTIVITY, GROUP_ACTIVITY } from '../../../constants/FeedEntryTypes';

export const kudosUpdateEndpoint = ({ entity }) => {
  return entity === GROUP_ACTIVITY ? ACTIVITY : snakeCase(entity);
};

export default { kudosUpdateEndpoint };
